import { GD } from "src/GD"

/**
 * POSTs a list request with `with_meta`. Empty filters are left out: the backend wants no `sort` for the default order.
 * Rows go through `mapRow` whether the backend pages or still answers with the bare array.
 */
export const requestListPage = async <T, S>(
	method: string,
	query: object,
	mapRow: (row: T) => T = row => row
): Promise<IAPIResponse<IListPage<T, S> | T[]>> => {
	const data = Object.fromEntries(
		Object.entries({ ...query, with_meta: true } as Record<string, unknown>).filter(([, value]) =>value !== undefined && value !== null && value !== "")
	)
	const res = await GD.REQ_API.request({ httpMethod: "POST", method, data })
	if (res.error || !res.data) return res as IAPIResponse<IListPage<T, S>>
	const body = res.data as unknown as IListPage<T, S> | T[]
	return { data: Array.isArray(body) ? body.map(mapRow) : { ...body, rows: (body.rows ?? []).map(mapRow) } }
}
